function TagName({tag}) {
	return (
            <div className='tagName'>
                <span>{tag}</span>
            </div>
    )
}

export default TagName
